import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppMenuitemComponent } from './app.menuitem.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        AppMenuitemComponent,
        TranslateModule
    ]
})
export class AppMenuComponent implements OnInit, OnDestroy {

    model: any[] = [];
    user: any;
    rawMenuData: any[] = [];
    languageSubscription: Subscription | undefined;
    private lastAppliedLang: string = '';

    constructor(
        private authService: AuthService,
        private translate: TranslateService
    ) { }

    ngOnInit() {
        // Ensure language is initialized
        const savedLang = localStorage.getItem('lang') || 'en';
        this.lastAppliedLang = this.translate.currentLang || savedLang;
        if (!this.translate.currentLang) {
            this.translate.use(savedLang);
        }
        this.authService.getCurrentUser().subscribe(user => {
            console.log("[Sidebar] -> user", user);
            if (user && user.menus) {
                this.rawMenuData = user.menus;
                this.model = user.menus.map((menuDTOO: any) => ({
                    items: menuDTOO.items.map((menu: any) => this.mapMenu(menu))
                }));
            } else {
                this.rawMenuData = [];
                this.model = [];
            }
        });

        // Subscribe to language changes
        this.languageSubscription = this.translate.onLangChange.subscribe((event) => {
            // Avoid rebuilding menu model when same language is re-applied on each route.
            if (event.lang === this.lastAppliedLang) {
                return;
            }
            this.lastAppliedLang = event.lang;
            this.updateMenuLabels(event.lang);
        });


    }

    ngOnDestroy() {
        if (this.languageSubscription) {
            this.languageSubscription.unsubscribe();
        }
    }

    updateMenuLabels(activeLang?: string) {
        if (this.rawMenuData && this.rawMenuData.length > 0) {
            this.model = this.rawMenuData.map((menuDTOO: any) => ({
                items: menuDTOO.items.map((menu: any) => this.mapMenu(menu, activeLang))
            }));
        }
    }

    /**
     * Maps a menu item recursively to the frontend model structure.
     * @param menu The menu object to map
     * @returns The mapped menu object
     */
    private mapMenu(menu: any, activeLang?: string): any {
        // Angular RouterLink accepts both strings and arrays
        // Keep routerLink as-is (string or array) - Angular handles both formats
        let routerLink = menu.routerLink;

        // If routerLink is a string, ensure it's properly formatted
        if (routerLink && typeof routerLink === 'string' && routerLink.trim() !== '') {
            // Ensure it starts with '/' for absolute paths
            if (!routerLink.startsWith('/')) {
                routerLink = '/' + routerLink;
            }
        }

        const currentLang = activeLang || this.translate.currentLang || localStorage.getItem('lang') || 'en';
        const isFrench = currentLang === 'fr' || currentLang.startsWith('fr-') || currentLang.startsWith('fr_');
        const label = isFrench
            ? (menu.labelFr ?? menu.labelfr ?? menu.label_fr ?? menu.labelFrench ?? menu.label)
            : menu.label;

        return {
            label: label,
            icon: menu.icon,
            routerLink: routerLink,
            items: menu.items?.map((submenu: any) => this.mapMenu(submenu, activeLang)) // Recursive mapping for nested menus
        };
    }




    //     this.model = [
    //        {
    //            items: [
    //                {
    //                    label: 'Dashboard',
    //                    icon: 'pi pi-fw pi-home',
    //                    routerLink: ['/app/dashboard']
    //                }
    //            ]
    //        },
    //        {
    //            label: 'Pages',
    //            icon: 'pi pi-fw pi-briefcase',
    //            items: [

    //                {
    //                    label: 'Send Money',
    //                    icon: 'pi pi-fw pi-user',
    //                    items: [
    //                         {
    //                            label: 'Send to Mobile money & Banks',
    //                            routerLink: ['/app/send-money']
    //                        },
    //                        {
    //                            label: 'Track Payments',
    //                            routerLink: ['/app/send-money/track-payments']
    //                        },
    //                        {
    //                            label: 'Beneficiaries & Payments lists',
    //                            routerLink: ['/app/send-money/beneficiaries-and-payments-lists']
    //                        },
    //                        {
    //                            label: 'Payment Reports',
    //                            routerLink: ['/app/send-money/payment-reports']
    //                        },
    //                        {
    //                            label: 'Schedule Payments',
    //                            routerLink: ['/app/send-money/schedule-payments']
    //                        },
    //                    ]
    //                },

    //            ]
    //        },

    //         {
    //             items: [
    //                 {
    //                     label: 'Salary Advance',
    //                     icon: 'pi pi-fw pi-home',
    //                     items: [
    //                         {
    //                             label: 'manage-requests',
    //                             routerLink: ['/app/salary-advance/manage-requests']
    //                         },
    //                         {
    //                             label: 'track-payments',
    //                             routerLink: ['/app/salary-advance/track-payments']
    //                         },
    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             items: [
    //                 {
    //                     label: 'Expance Management',
    //                     icon: 'pi pi-fw pi-home',
    //                     items: [
    //                         {
    //                             label: 'track-payments',
    //                             routerLink: ['/app/expense-management/track-payments/track-retirement-payments']
    //                         },
    //                         {
    //                             label: 'manage-retirements',
    //                             routerLink: ['/app/expense-management/manage-retirements']
    //                         }
    //                     ]
    //                 },
    //             ]
    //         },

    //    ];

    @Output() childLogoutClicked = new EventEmitter<string>();
    childlogoutclick() {
        this.childLogoutClicked.emit();
    }
}





